export class EmailTypes {
  static ContactForm = 'ContactForm';
  static RequestProduct = 'RequestProduct';
  static JobApplication = 'JobApplication';
  static RequestDemo = 'RequestDemo';
}
